/**
 * Created by Jie Gao on 05/24/2019.
 */

import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class DTReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    public createStateAnimation(symbol:StateReelSymbol, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        if(symbol.symName === ReelSymbolName.EMPTY) {
            return null;
        }

        return super.createStateAnimation(symbol, stateConfig);
    }

    protected expandStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if(stateAnimation) {
            stateAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        }
        return stateAnimation;
    }

    protected attentionStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);

        if(stateAnimation) {
            if(symbol.symName === "M") {
                stateAnimation.blendMode = PIXI.BLEND_MODES.NORMAL;
            }
        }
        return stateAnimation;
    }
}